import React from 'react';
import Navbar from '../components/Navbar';
import { Card, CardContent } from '../components/ui/card';
import { AlertTriangle } from 'lucide-react';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="refund-policy">
      <Navbar />

      <div className="pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl font-bold text-slate-900 mb-2">Refund Policy</h1>
          <p className="text-slate-500 mb-8">Last updated: January 2026</p>

          {/* Important Notice */}
          <Card className="border-amber-200 bg-amber-50 mb-8">
            <CardContent className="p-6 flex gap-4">
              <AlertTriangle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-amber-800 mb-2">Important: No Refunds on Digital Products</h3>
                <p className="text-amber-700">
                  Due to the digital and downloadable nature of our courses, all sales are final. 
                  We encourage you to review course descriptions, preview lessons, and curriculum 
                  carefully before making a purchase.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-slate-200">
            <CardContent className="p-8 prose prose-slate max-w-none">
              <h2>Our Policy</h2>
              <p>
                AISkillFlow provides digital educational content that is immediately accessible upon purchase. 
                Because our courses contain downloadable materials and streaming content that cannot be 
                "returned," we maintain a strict no-refund policy.
              </p>

              <h2>Why No Refunds?</h2>
              <ul>
                <li><strong>Instant Access:</strong> Course content is immediately available after purchase</li>
                <li><strong>Downloadable Content:</strong> Many courses include downloadable resources that cannot be retrieved</li>
                <li><strong>Digital Nature:</strong> Unlike physical products, digital content cannot be returned</li>
                <li><strong>Instructor Protection:</strong> This policy protects instructors who invest time creating content</li>
              </ul>

              <h2>Before You Purchase</h2>
              <p>To help you make an informed decision, we provide:</p>
              <ul>
                <li><strong>Free Preview Lessons:</strong> Many courses offer free preview lessons</li>
                <li><strong>Detailed Descriptions:</strong> Complete course curriculum and learning objectives</li>
                <li><strong>Instructor Information:</strong> Background on who created the course</li>
                <li><strong>Student Reviews:</strong> Feedback from other learners (when available)</li>
              </ul>

              <h2>Exceptions</h2>
              <p>We may consider exceptions in rare circumstances:</p>
              <ul>
                <li><strong>Duplicate Purchase:</strong> If you accidentally purchased the same course twice</li>
                <li><strong>Technical Issues:</strong> If you experience persistent technical problems that prevent course access and our support team cannot resolve them</li>
                <li><strong>Course Removal:</strong> If a course is removed from the platform before you complete it</li>
              </ul>

              <h2>How to Request an Exception</h2>
              <p>If you believe your situation qualifies for an exception:</p>
              <ol>
                <li>Contact us within 48 hours of purchase</li>
                <li>Provide your order details and explain the situation</li>
                <li>Our team will review your request within 3-5 business days</li>
              </ol>

              <h2>Instructor Subscriptions</h2>
              <p>
                Instructor subscription fees are non-refundable. You may cancel your subscription at any time, 
                but the current billing period will not be refunded. Your subscription benefits will remain 
                active until the end of the billing period.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have questions about this policy or need assistance, please contact our support team:
              </p>
              <p><strong>Email:</strong> info@aiskillflowpro.com</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
